import React, { useState } from "react";
import {
  Grid,
  Button,
  ListItem,
  Tooltip,
  List,
  ListItemIcon,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  DialogContentText,
  IconButton,
} from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import { Mention, MentionsInput } from "react-mentions";
import serviciosTablero from "utils/serviciosTablero";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AttachFile from "@material-ui/icons/AttachFile";
import { AvatarParticipante } from "views/Tablero/Components/Item";
import ViewAdjuntosComentario from "./Actions/ViewAdjuntosComentario";
import ModalAdjuntosComentario from "./Actions/ModalAdjuntosComentario";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import { makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  opcionesComentarios: {
    backgroundColor: "#22272B",
    borderRadius: "0 10px 10px 0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    alignItems: "flex-end",
  },
  btnAdjunto: {
    backgroundColor: "gray",
    fontSize: "25px",
    borderRadius: "5px",
    padding: "2px",
    "&:hover": {
      backgroundColor: "#CCCCCC",
      color: "black",
    },
  },
  btnEliminar: {
    color: red[300],
    fontSize: "25px",
    "&:hover": {
      backgroundColor: "#CCCCCC",
      color: red[300],
      borderRadius: "5px",
    },
  },
  btnEditar: {
    fontSize: "25px",
    "&:hover": {
      backgroundColor: "#CCCCCC",
      color: "white",
      borderRadius: "5px",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const stylesMentionNoEdit = {
  userMention: {
    backgroundColor: "#999999",
    borderRadius: "9px",
    color: '#000000'
  },
  mention: {
    control: {
      //backgroundColor: "#2C2C2C",
      fontFamily: "Arial",
      color: "#CCCCCC",
      border: "none",
    },
    "&multiLine": {
      control: {
        fontFamily: "Arial",
        minHeight: 63,
        color: "#CCCCCC",
      },
      highlighter: {
        padding: 9,
        border: "1px solid transparent",
        color: '#000000'
      },
      input: {
        padding: 9,
        border: "none",
        color: "#CCCCCC",
        "&focused": {
          backgroundColor: "#4d90fe",
        },
      },
    },
    "&singleLine": {
      display: "inline-block",
      width: 180,
      highlighter: {
        padding: 1,
        //border: "2px inset transparent",
      },
      input: {
        padding: 1,
        border: "none",
        color: "#CCCCCC",
      },
    },
    suggestions: {
      list: {
        backgroundColor: "#282E33",
        border: "1px solid rgba(0,0,0,0.15)",
        borderRadius: '3px',
        color: '#89939E',
        fontSize: 16,
      },
      item: {
        padding: "5px 15px",
        borderBottom: "1px solid rgba(0,0,0,0.15)",
        "&focused": {
          backgroundColor: "#323940",
        },
      },
    },
  },
};

const Actividades = ({
  activities,
  setActivities,
  editActivity,
  setCargando,
  setMensaje,
  creatorName,
  tarjeta,
  miembros,
  usuariosMention,
  stylesMention,
  getFileIcon,
  idjerarquia,
  usuario,
  permisos,
}) => {
  const classesTablero = useStylesTablero();
  const classes = useStyles();
  const [isEditingIndex, setIsEditingIndex] = useState(null);
  const [editText, setEditText] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [open, setOpen] = useState(false); //Modal de confirmacion
  const [modalViewAdjuntos, setModalViewAdjuntos] = useState({ open: false });
  const [adjuntoComentario, setAdjuntoComentario] = useState({
    open: false,
    files: [],
  });
  const [archivosOriginales, setArchivosOriginales] = useState(false);

  const handleEditClick = (index) => {
    setEditText(activities[index].texto);
    setIsEditingIndex(index);
  };

  const handleSaveEdit = (defaultValue) => {
    if (isEditingIndex !== null) {
      let textValue =
        defaultValue !== "" && editText === "" ? defaultValue : editText;
      editActivity(
        isEditingIndex,
        textValue,
        adjuntoComentario?.files,
        archivosOriginales
      );
      setIsEditingIndex(null);
      setEditText("");
    }
  };
  const handleOpen = (index) => {
    setSelectedIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedIndex(null);
  };
  const handleConfirmDelete = () => {
    if (selectedIndex !== null) {
      deleteActivity(selectedIndex);
      handleClose();
    }
  };
  const deleteActivity = (index) => {
    const activityToDelete = activities[index];
    const datosActividad = {
      idcomentario: activityToDelete.idcomentario,
      idtarjeta: tarjeta
    };

    serviciosTablero.eliminarComentarios(
      (estado, mensaje, data) => {
        if (estado === 1) {
          setActivities(data);
          setMensaje({ open: true, status: estado, value: mensaje });
        } else {
          setMensaje({
            open: true,
            status: -1,
            value: "Error al eliminar la actividad:",
          });
        }
      },
      setCargando,
      datosActividad
    );
  };

  const handleClickVerFiles = (index) => () => {
    setModalViewAdjuntos({
      open: true,
      data: activities[index],
    });
  };
  const handleClickEditAdjuntos = (index) => () => {
    let comentario = activities[index];
    let filesComentarios = [];

    if (!archivosOriginales) {
      setArchivosOriginales(comentario?.archivos || []);
      filesComentarios =
        comentario?.archivos.map((file) => {
          return {
            data: file.file,
            mimeType: file.mimeType,
            nombre: file.nombre,
            idarchivo: file?.idarchivo,
          };
        }) || [];
      setAdjuntoComentario({ open: true, files: filesComentarios });
      return;
    }

    setAdjuntoComentario({ ...adjuntoComentario, open: true });
  };

  return (
    <List style={{ padding: "0px", marginBottom: "10px" }}>
      {activities.map((activity, index) => (
        <ListItem
          key={index}
          style={{ marginLeft: "-15px", marginBottom: "20px" }}
        >
          <Grid container spacing={3}>
            <Grid item xs={1}>
              <AvatarParticipante
                infoColaborador={{
                  nombre: activity?.nombre || "",
                  correo: activity?.correo || "",
                  color: activity?.color || null,
                  avatar: activity?.avatar || "",
                }}
              />
            </Grid>
            {isEditingIndex === index ? (
              <>
                <Grid item xs={11}>
                  <MentionsInput
                    style={stylesMention.mention}
                    value={editText}
                    onChange={(e) => setEditText(e.target.value)}
                  >
                    <Mention
                      data={usuariosMention}
                      style={stylesMention.userMention}
                      displayTransform={(id, username) => `@${username}`}
                    />
                  </MentionsInput>
                  <Button
                    variant="contained"
                    color="#146C94"
                    onClick={handleClickEditAdjuntos(index)}
                    style={{
                      backgroundColor: "gray",
                      margin: "5px 10px 0 10px",
                    }}
                    size="small"
                    title="Editar adjuntos archivos"
                  >
                    <AttachFile />
                  </Button>

                  <Button
                    onClick={() => handleSaveEdit(activity?.texto || "")}
                    className={classesTablero.btnAceptar}
                    size="small"
                    style={{
                      margin: "5px 10px 0 10px",
                      justifyContent: "flex-end",
                    }}
                  >
                    Guardar
                  </Button>
                  <Button
                    onClick={() => {
                      setIsEditingIndex(null);
                      setArchivosOriginales(false);
                    }}
                    className={classesTablero.btnCancelar}
                    size="small"
                    style={{
                      margin: "5px 10px 0 0",
                      justifyContent: "flex-end",
                    }}
                  >
                    Cancelar
                  </Button>
                </Grid>
              </>
            ) : (
              <>
                <Grid
                  item
                  xs={9}
                  style={{
                    backgroundColor: "#22272B",
                    borderRadius: "10px 0 0 10px",
                  }}
                >
                  <MentionsInput
                    style={stylesMentionNoEdit.mention}
                    value={activity.texto}
                    onChange={(e) => {}}
                  >
                    <Mention
                      data={usuariosMention}
                      style={stylesMentionNoEdit.userMention}
                      displayTransform={(id, username) => `@${username}`}
                    />
                  </MentionsInput>
                  {activity?.archivos?.length > 0 && (
                    <Tooltip
                      title={(activity?.archivos?.length || 0) + " Adjuntos"}
                    >
                      <AttachFileIcon
                        color="black"
                        onClick={handleClickVerFiles(index)}
                        className={classes.btnAdjunto}
                        size="small"
                        title="Archivos adjuntos"
                      />
                    </Tooltip>
                  )}
                </Grid>
                <Grid item xs={2} className={classes.opcionesComentarios}>
                  <ListItemIcon>
                    <Button
                      onClick={() => handleEditClick(index)}
                      color="secondary"
                      className={classes.btnEditar}
                      title="Editar"
                      disabled={!(idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol) || activity?.idcrea == usuario[0]?.idusuario)}
                    >
                      <EditIcon />
                    </Button>
                    <Button
                      onClick={() => handleOpen(index)}
                      className={classes.btnEliminar}
                      title="Eliminar"
                      disabled={!(idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol))}
                    >
                      <DeleteIcon />
                    </Button>
                  </ListItemIcon>
                </Grid>
              </>
            )}
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>
                ¡ADVERTENCIA!{" "}
                <IconButton
                  aria-label="close"
                  className={classes.closeButton}
                  onClick={handleClose}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <DialogContentText style={{ color: "white" }}>
                  El comentario se eliminará permanentemente, ¿desea continuar?
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ justifyContent: "flex-end" }}>
                <Button onClick={handleClose} color="secondary">
                  Cancelar
                </Button>
                <Button
                  onClick={handleConfirmDelete}
                  className={classesTablero.btnEliminar}
                >
                  Eliminar
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </ListItem>
      ))}
      {modalViewAdjuntos?.open && (
        <ViewAdjuntosComentario
          modalViewAdjuntos={modalViewAdjuntos}
          setModalViewAdjuntos={setModalViewAdjuntos}
          setMensaje={setMensaje}
          setCargando={setCargando}
          tarjeta={tarjeta}
          data={modalViewAdjuntos?.data || {}}
          getFileIcon={getFileIcon}
        />
      )}
      {adjuntoComentario?.open && (
        <ModalAdjuntosComentario
          adjuntoComentario={adjuntoComentario}
          setAdjuntoComentario={setAdjuntoComentario}
          tarjeta={tarjeta}
          setCargando={setCargando}
          setMensaje={setMensaje}
          onClose={() => setAdjuntoComentario({ open: false, files: [] })}
          isEdit={true}
        />
      )}
    </List>
  );
};

export default Actividades;
